//imports
import {
    ALERT_TYPES_DETAILS_OPEN_MODAL,
    ALERT_TYPES_DETAILS_REQUEST,
    ALERT_TYPES_DETAILS_RESULT,
    ALERT_TYPES_DEVICE_MODEL_REQUEST,
    ALERT_TYPES_DEVICE_MODEL_RESULT,
    ALERT_TYPES_UPDATE_REQUEST,
    ALERT_TYPES_UPDATE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    alertType: null,
    devicesModels: [],
    update: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ALERT_TYPES_DETAILS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, alertType: action.payload.data }

        case ALERT_TYPES_DETAILS_REQUEST:
            return { ...state, loading: true }

        case ALERT_TYPES_DETAILS_RESULT:
            return { ...state, loading: false, result: action.payload.data }
        case ALERT_TYPES_DEVICE_MODEL_REQUEST:
            return { ...state, loading: true }

        case ALERT_TYPES_DEVICE_MODEL_RESULT:
            return { ...state, loading: false, devicesModels: action.payload.data }

        case ALERT_TYPES_UPDATE_REQUEST:
            return { ...state, loading: true }

        case ALERT_TYPES_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "ALERT_TYPES_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};